import {
    StartedGameDto, StartedPuzzleDto, StartGameRequestDto, SubmitGameAnswersDto 
} from '../utils/types'
import apiClient from './api-client'

export const startGame = async (request: StartGameRequestDto): Promise<StartedGameDto> => {
    const res = await apiClient.post('/v1/games', request)
    return res.data
}

export const getStartedGames = async (): Promise<StartedGameDto[]> => {
    const res = await apiClient.get('/v1/games')
    return res.data
}

export const getStartedGame = async (gameId: string): Promise<StartedGameDto> => {
    const res = await apiClient.get(`/v1/games/${gameId}`)
    return res.data
}

export const cancelGame = async (gameId: string) => {
    const res = await apiClient.delete(`/v1/games/${gameId}`)
    return res.data
}

export const submitGameAnswers = async (
    gameId: string, puzzleId: string, request: SubmitGameAnswersDto
): Promise<StartedPuzzleDto> => {
    const res = await apiClient.post(`/v1/games/${gameId}/puzzle/${puzzleId}/answers`, request)
    return res.data
}
